<template>
  <div>
    <WdsRadioGroup
      v-model:checked="allowStatementOfWorkEngagement"
      label="Will your company offer Statement of Work (SOW) contracts?"
      name="allow_sow_engagement"
    >
      <WdsRadio value="unknown">Not sure</WdsRadio>
      <WdsRadio :value="0">Deny offering of Statement of Work (SOW) contracts</WdsRadio>
      <WdsRadio :value="1">Allow offering of Statement of Work (SOW) contracts</WdsRadio>
    </WdsRadioGroup>

    <WdsAlert
      v-if="errorMessage && showError"
      class="tw-mt-2"
      closable
      error
      @close="showError = false"
    >
      {{ $t('An error occurred') }}
      <template #description>
        {{ errorMessage }}
      </template>
    </WdsAlert>
    <WdsAlert v-else-if="showSuccess" class="tw-mt-2" closable success @close="showSuccess = false">
      {{ $t('Thanks, your settings has been updated') }}
    </WdsAlert>

    <div class="tw-mt-4">
      <WdsButton :disabled="loading" primary @click="onSave">
        <div class="tw-flex tw-items-center">
          <span>Save</span>
          <WdsSpinner v-show="loading" class="tw-ml-2" indeterminate>
            <WdsIcon name="bam" :size="16" />
          </WdsSpinner>
        </div>
      </WdsButton>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import {
  WdsAlert,
  WdsButton,
  WdsIcon,
  WdsRadio,
  WdsRadioGroup,
  WdsSpinner,
} from '@worksome/wds-components'
import { UpdateComplianceMutation } from '@/components/compliances/mutations/UpdateComplianceMutation'
import { FormValidation } from '@/utils/formValidation'
import { booleanToIntNullable, intToBooleanNullable } from '@/utils/forms/ValueNormalisers'

export default {
  components: {
    WdsAlert,
    WdsButton,
    WdsIcon,
    WdsRadio,
    WdsRadioGroup,
    WdsSpinner,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const errors = ref([])
    const internalComplianceData = reactive(props.complianceData)
    const loading = ref(false)
    const showError = ref(false)
    const showSuccess = ref(false)

    return {
      errors,
      internalComplianceData,
      loading,
      showError,
      showSuccess,
    }
  },
  computed: {
    allowStatementOfWorkEngagement: {
      get() {
        const { allowStatementOfWorkEngagement } = this.internalComplianceData
        if (allowStatementOfWorkEngagement === null) {
          return 'unknown'
        }
        return booleanToIntNullable(allowStatementOfWorkEngagement)
      },
      set(allowStatementOfWorkEngagement) {
        let value = null
        if (allowStatementOfWorkEngagement !== 'unknown') {
          value = intToBooleanNullable(allowStatementOfWorkEngagement)
        }

        this.internalComplianceData.allowStatementOfWorkEngagement = value
        this.$emit('update:complianceData', this.internalComplianceData)
      },
    },
    errorMessage() {
      return FormValidation.containsErrorMessage(this.errors)
    },
  },
  methods: {
    async onSave() {
      this.loading = true

      const data = JSON.stringify({
        allow_sow_engagement: this.internalComplianceData.allowStatementOfWorkEngagement,
      })

      try {
        await this.$apollo.mutate({
          mutation: UpdateComplianceMutation,
          variables: {
            input: {
              name: 'UK_STATEMENT_OF_WORK',
              data,
            },
          },
        })

        this.showSuccess = true
      } catch ({ graphQLErrors }) {
        this.errors = graphQLErrors
        this.showError = true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
